import React, { useEffect } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import "./MessagePage.css";
import { Row, Spin, Col, message } from "antd";
import MessageTable from "./MessageTable/MessageTable";
import { useState } from "react";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import {
  ArrowLeftOutlined,
  ConsoleSqlOutlined,
  MailOutlined,
  MessageOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { showMessageModal } from "./MessageModal/showMessageModal";
import { showSmsModal } from "./SmsModal/showSmsModal";
import { useSelector } from "react-redux";
import {
  apiGetDivisionAll,
  apiGetDivisionTreeList,
} from "services/divisionService";
import { getEmailCampaigns, getEmailCampaignDetail } from "services/emailCampaignService";
import { useHistory } from "react-router";
import { ROUTE_AUDIENCE } from "navigation/CONSTANTS";
function MessagePage(props) {
  const history = useHistory();
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);

  const [isBusy, setIsBusy] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [isDetail, setIsDetail] = useState(false);

  useEffect(() => {
    if (userDataStore?.token) {
      getData();
    }
    if (
      appDataStore?.club !== undefined &&
      appDataStore?.curRegistration !== undefined
    ) {
      getDivisionTreeList();
    }
  }, [userDataStore?.token, appDataStore?.club, appDataStore?.curRegistration]);
  const getData = async () => {
    if (!userDataStore?.token) {
      return;
    }
    setIsBusy(true);
    try {
      const campaigns = await getEmailCampaigns({
        token: userDataStore.token,
      });
      const emailList = (Array.isArray(campaigns) ? campaigns : []).map((c) => ({
        ...c,
        message_type: "Email",
      }));
      setMessageList(emailList);
    } catch (err) {
      message.error(err || "Failed to load email campaigns");
    } finally {
      setIsBusy(false);
    }
  };
  const getDivisionTreeList = () => {
    if (!userDataStore?.token || !userDataStore?.user?.ID || !appDataStore?.curRegistration?.ID) {
      return;
    }
    setDivisionList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("user_id", userDataStore.user.ID);
    params.append("sport_type", userDataStore.sport_type);
    params.append("registration_id", appDataStore.curRegistration.ID);
    setIsBusy(true);
    apiGetDivisionTreeList(params)
      .then((res) => {
        setIsBusy(false);
        if (res != null) {
          if (res.length > 0) {
            setDivisionList(res);
          }
        }
      })
      .catch((err) => {
        message.error(err);
        setIsBusy(false);
      });
  };
  const onMailDlg = async () => {
    var resInfo = await showMessageModal({
      title: "Send Mail",
      token: userDataStore.token,
      dataList: divisionList,
      // default From: prefer user's first name, fallback to email
      from: (userDataStore?.user?.FNAME) || (userDataStore?.user?.EMAIL) || "",
    });
    if (resInfo == null || !resInfo.success) return;
    // Reload campaigns list after successful send
    getData();
  };
  const onSmsDlg = async () => {
    var resInfo = await showSmsModal({
      title: "Send SMS",
      token: userDataStore.token,
      smsCost: userDataStore.sms_cost || 0,
    });
    if (resInfo == null || !resInfo.success) return;
    // Add SMS result to the table
    const results = resInfo.results || {};
    const smsEntry = {
      message_type: "SMS",
      subject: "(SMS Message)",
      audience_names: results.audience_names || ["SMS"],
      recipients_count: (results.successful || 0) + (results.failed || 0),
      created_at: new Date().toISOString(),
      has_attachment: false,
      sms_successful: results.successful || 0,
      sms_failed: results.failed || 0,
    };
    setMessageList((prev) => [smsEntry, ...prev]);
  };
  const onDetail = async (record) => {
    if (!record.campaign_id) return;
    setIsDetail(true);
    setMessageList([]);
    setIsBusy(true);
    try {
      const detail = await getEmailCampaignDetail({
        token: userDataStore.token,
        campaign_id: record.campaign_id,
      });
      if (detail && detail.recipients) {
        setMessageList(Array.isArray(detail.recipients) ? detail.recipients : []);
      }
    } catch (err) {
      message.error(err || "Failed to load campaign details");
    } finally {
      setIsBusy(false);
    }
  };
  const onClear = () => {
    setIsDetail(false)
    getData();
  };
  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <Row justify="space-between" align="middle" style={{ width: "100%" }}>
          <Col>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {isDetail && (
                <ArrowLeftOutlined
                  style={{ color: "var(--mainColor)", cursor: "pointer" }}
                  onClick={() => onClear()}
                />
              )}
              <CommonButton
                onClick={() => {
                  history.push(ROUTE_AUDIENCE);
                }}
              >
                 <UsergroupAddOutlined style={{ marginRight: 10 }} />
                {"Audience Dashboard"}
              </CommonButton>
            </div>
          </Col>

          <Col>
            <div style={{ display: "flex", gap: 10 }}>
              <CommonButton
                onClick={() => {
                  onMailDlg();
                }}
              >
                <MailOutlined style={{ marginRight: 10 }} />
                {"Create New Email"}
              </CommonButton>
              {userDataStore.sms_enabled && (
                <CommonButton
                  onClick={() => {
                    onSmsDlg();
                  }}
                >
                  <MessageOutlined style={{ marginRight: 10 }} />
                  {"Create New SMS"}
                </CommonButton>
              )}
            </div>
          </Col>
        </Row>

        <MessageTable
          dataList={messageList}
          onDetail={onDetail}
          isDetail={isDetail}
        />
      </Spin>
    </CommonDivWidget>
  );
}

export default MessagePage;
